import type { ReportConfig } from 'types/reports';
import api from 'helpers/api'

export const getReportConfigs = () => api.get('/configs/report');
export const saveReportConfig = (config: any) => api.post('/configs/report', config)
export const editReportConfig = (config: any, reportId: number) => api.patch(`/configs/report/${reportId}`, config)
export const deleteReportConfig = (id: number) => api.delete(`/configs/report/${id}`)

export const fetchReportConfigs = () => api.get<ReportConfig[]>('/configs/report');
